/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_USER_PROFILE_SOCIAL
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted social media section from UserProfileForm.tsx.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/user-profile/components/SocialMedia.tsx
 */
import React from "react";
import { Form } from "react-bootstrap";

interface SocialMediaProps {
  formik: any;
}

export const SocialMedia: React.FC<SocialMediaProps> = ({ formik }) => {
  // [2026-02-06] Changed type="url" to type="text" to use Yup validation messages instead of browser default
  return (
    <div className="mt-3 social-links-group">
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social.svg" alt="LinkedIn" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("linkedIn")} isInvalid={!!(formik.touched.linkedIn && formik.errors.linkedIn)} placeholder="LinkedIn page link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (1).svg" alt="Facebook" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("facebook")} isInvalid={!!(formik.touched.facebook && formik.errors.facebook)} placeholder="Facebook page link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (2).svg" alt="Instagram" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("instagram")} isInvalid={!!(formik.touched.instagram && formik.errors.instagram)} placeholder="Instagram page link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (3).svg" alt="X" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("x")} isInvalid={!!(formik.touched.x && formik.errors.x)} placeholder="X page link" />
      </div>
    </div>
  );
};
